<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" role="doc-toc">
<h1><strong>Contents</strong></h1>
<ol class="bbb-rw" epub:type="list"><li><a href="#/cover">Cover</a></li>
<li style="margin-top:6pt;"><a href="#/s001BookTitlePage01">Title Page</a></li>
<li style="margin-top:6pt;"><a href="#/s033Copyright01">Copyright</a></li>
<li style="margin-top:6pt;"><a href="#/s003Dedication01">Dedication</a></li>
<li style="margin-top:16pt;"><a href="#/s004Chapter001#title-num1" id="title-num1a">Chapter 1</a></li>
<li style="margin-top:6pt;"><a href="#/s005PushDown001#title-num2" id="title-num2a">Chapter 2</a></li>
<li style="margin-top:6pt;"><a href="#/s006PushDown002#title-num3" id="title-num3a">Chapter 3</a></li>
<li style="margin-top:6pt;"><a href="#/s007Chapter002#title-num4" id="title-num4a">Chapter 4</a></li>
<li style="margin-top:6pt;"><a href="#/s008Chapter003#title-num5" id="title-num5a">Chapter 5</a></li>
<li style="margin-top:6pt;"><a href="#/s009Chapter004#title-num6" id="title-num6a">Chapter 6</a></li>
<li style="margin-top:6pt;"><a href="#/s010Chapter005#title-num7" id="title-num7a">Chapter 7</a></li>
<li style="margin-top:6pt;"><a href="#/s011Chapter006#title-num8" id="title-num8a">Chapter 8</a></li>
<li style="margin-top:6pt;"><a href="#/s012Chapter007#title-num9" id="title-num9a">Chapter 9</a></li>
<li style="margin-top:6pt;"><a href="#/s013PushDown003#title-num10" id="title-num10a">Chapter 10</a></li>
<li style="margin-top:6pt;"><a href="#/s014Chapter008#title-num11" id="title-num11a">Chapter 11</a></li>
<li style="margin-top:6pt;"><a href="#/s015Chapter009#title-num12" id="title-num12a">Chapter 12</a></li>
<li style="margin-top:6pt;"><a href="#/s016Chapter010#title-num13" id="title-num13a">Chapter 13</a></li>
<li style="margin-top:6pt;"><a href="#/s017Chapter011#title-num14" id="title-num14a">Chapter 14</a></li>
<li style="margin-top:6pt;"><a href="#/s018Chapter012#title-num15" id="title-num15a">Chapter 15</a></li>
<li style="margin-top:6pt;"><a href="#/s019Chapter013#title-num16" id="title-num16a">Chapter 16</a></li>
<li style="margin-top:6pt;"><a href="#/s020PushDown004#title-num17" id="title-num17a">Chapter 17</a></li>
<li style="margin-top:6pt;"><a href="#/s021PushDown005#title-num18" id="title-num18a">Chapter 18</a></li>
<li style="margin-top:6pt;"><a href="#/s022Chapter014#title-num19" id="title-num19a">Chapter 19</a></li>
<li style="margin-top:6pt;"><a href="#/s023Chapter015#title-num20" id="title-num20a">Chapter 20</a></li>
<li style="margin-top:6pt;"><a href="#/s024Chapter016#title-num21" id="title-num21a">Chapter 21</a></li>
<li style="margin-top:6pt;"><a href="#/s025Chapter017#title-num22" id="title-num22a">Epilogue</a></li>
<li style="margin-top:16pt;"><a href="#/discoverpage">Discover More</a></li>
<li style="margin-top:6pt;"><a href="#/s026Opener01" id="teaser001">A Preview of <em><span style="display:none">"</span>Last Kiss of Summer<span style="display:none">"</span></em></a></li>
<li style="margin-top:6pt;"><a href="#/s029AdCard01#h11" id="adcard">Also by Marina Adair</a></li>
</ol>
</nav>
<nav class="ccc-rw" epub:type="landmarks">
<h1>Navigation</h1>
<ol class="bbb-rw" epub:type="list">
<li><a epub:type="cover" href="#/cover">Begin Reading</a></li>
<li><a epub:type="toc" href="#/TOC">Table of Contents</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?aa248774